var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinLabel = function SvgPinLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pin-label_svg__a)",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.643 13.67-2.357 2.358M6.343 10.37l6.6 6.6.83-.83a1.333 1.333 0 0 0 .32-1.366l-.415-1.264a1.334 1.334 0 0 1 .32-1.367L16.244 9.9l.47.472A1.333 1.333 0 0 0 18.6 8.485l-3.77-3.771A1.333 1.333 0 0 0 12.942 6.6l.471.471-2.244 2.244a1.333 1.333 0 0 1-1.367.32L8.54 9.221a1.333 1.333 0 0 0-1.367.32l-.83.83Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pin-label_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(45 6 14.485)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgPinLabel;